/* NeuroPulse · página FAQ (gerado de previa/paginas/faq.html por tema/converter_paginas.py) */
/* ---------- FAQ (seção própria: vai para np-faq.js da seção; não depende de JS global) ----------
   busca de verdade (pergunta + resposta + palavras extras; sem acento e sem maiúscula; destaca o termo;
   contagem ao vivo; categoria sem resultado some; ?q= na URL) · acordeões com aria-expanded e
   hidden="until-found" (o Cmd+F do navegador abre a resposta) · categorias com scrollspy e
   barra de leitura (coluna fixa no desktop, abas roláveis presas sob o cabeçalho no celular) · link direto
   para categoria (#shipping) ou pergunta (#q-...) */
(function(){
  var root = document.querySelector('[data-npp-fq]'); if (!root) return;
  var doc = document.documentElement, MQ = matchMedia('(max-width: 989px)'), CALMO = matchMedia('(prefers-reduced-motion: reduce)');
  var input = root.querySelector('[data-npp-fq-input]'), limpar = root.querySelector('[data-npp-fq-clear]'),
      status = root.querySelector('[data-npp-fq-status]'), vazio = root.querySelector('[data-npp-fq-empty]'),
      pedir = root.querySelector('[data-npp-fq-ask]'), nav = root.querySelector('[data-npp-fq-nav]'),
      barra = root.querySelector('[data-npp-fq-tabs]'), main = root.querySelector('[data-npp-fq-main]');
  var itens = [].slice.call(root.querySelectorAll('[data-npp-fq-it]')),
      grupos = [].slice.call(root.querySelectorAll('[data-npp-fq-grp]')),
      abas = [].slice.call(root.querySelectorAll('[data-npp-fq-tab]')),
      extras = [].slice.call(root.querySelectorAll('[data-npp-fq-extra]'));
  var dobra = function(s){ return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  var plural = function(n, um, varios){ return n === 1 ? um : varios.replace('{n}', n); };

  /* ---------- acordeões ---------- */
  function abrir(it, on){
    it._b.setAttribute('aria-expanded', on ? 'true' : 'false');
    if (on) it._p.removeAttribute('hidden'); else it._p.setAttribute('hidden', 'until-found');
    it.classList.toggle('is-open', on);
  }
  itens.forEach(function(it){
    it._b = it.querySelector('.npp-fq__q'); it._p = it.querySelector('.npp-fq__a');
    it._qt = it.querySelector('.npp-fq__qt'); it._at = it.querySelector('.npp-fq__at');
    it._qh = it._qt.innerHTML; it._ah = it._at.innerHTML; it._ini = it._b.getAttribute('aria-expanded') === 'true';
    it._tx = dobra(it._qt.textContent + ' ' + it._at.textContent + ' ' + (it.getAttribute('data-k') || ''));
    it._g = it.closest('[data-npp-fq-grp]');
    it._b.addEventListener('click', function(){ abrir(it, it._b.getAttribute('aria-expanded') !== 'true'); });
    it._p.addEventListener('beforematch', function(){ abrir(it, true); });   /* Cmd+F achou texto numa resposta fechada */
  });

  /* ---------- destaque do termo (acha sem acento, marca no texto original) ---------- */
  function marcar(el, termos){
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nos = [], n;
    while ((n = w.nextNode())) nos.push(n);
    nos.forEach(function(no){
      var s = no.nodeValue, f = '', mapa = [], faixas = [];
      for (var i = 0; i < s.length; i++){ var c = dobra(s[i]); for (var j = 0; j < c.length; j++){ f += c[j]; mapa.push(i); } }
      termos.forEach(function(t){ var k = 0, x; while ((x = f.indexOf(t, k)) > -1){ faixas.push([mapa[x], mapa[x + t.length - 1] + 1]); k = x + t.length; } });
      if (!faixas.length) return;
      faixas.sort(function(a, b){ return a[0] - b[0]; });
      var juntas = [faixas[0]];
      faixas.slice(1).forEach(function(r){ var u = juntas[juntas.length - 1]; if (r[0] <= u[1]) u[1] = Math.max(u[1], r[1]); else juntas.push(r); });
      var frag = document.createDocumentFragment(), p = 0;
      juntas.forEach(function(r){
        if (r[0] > p) frag.appendChild(document.createTextNode(s.slice(p, r[0])));
        var m = document.createElement('mark'); m.className = 'npp-fq__hl'; m.textContent = s.slice(r[0], r[1]); frag.appendChild(m); p = r[1];
      });
      if (p < s.length) frag.appendChild(document.createTextNode(s.slice(p)));
      no.parentNode.replaceChild(frag, no);
    });
  }

  /* ---------- busca ---------- */
  function termosDe(q){ return dobra(q).replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(function(t){ return t.length > 1 || /\d/.test(t); }); }
  var ultimoQ = null;
  function buscar(q, rolar){
    q = q || ''; var termos = termosDe(q), ativa = termos.length > 0;
    if (ultimoQ === termos.join(' ') && !rolar) { limpar.hidden = !q; return; }
    ultimoQ = termos.join(' ');
    root.classList.toggle('is-search', ativa);
    var total = 0;
    itens.forEach(function(it){
      it._qt.innerHTML = it._qh; it._at.innerHTML = it._ah;
      if (!ativa){ it.hidden = false; abrir(it, it._ini); return; }
      var formas = [], ok = termos.every(function(t){
        if (it._tx.indexOf(t) > -1){ formas.push(t); return true; }
        if (t.length > 3 && t.slice(-1) === 's' && it._tx.indexOf(t.slice(0, -1)) > -1){ formas.push(t.slice(0, -1)); return true; }   /* "refunds" acha "refund" */
        return false; });
      it.hidden = !ok;
      if (ok){ total++; marcar(it._qt, formas); marcar(it._at, formas); abrir(it, true); }
    });
    var porGrupo = {};
    grupos.forEach(function(g){
      var n = g.querySelectorAll('[data-npp-fq-it]:not([hidden])').length;
      porGrupo[g.id] = n; g.hidden = ativa && !n;
    });
    extras.forEach(function(e){ e.hidden = ativa; });
    abas.forEach(function(a){
      var id = a.getAttribute('data-npp-fq-tab'), n = porGrupo[id];
      var sem = ativa && !n && id !== 'all'; a.classList.toggle('is-none', sem);   /* "All" sempre leva de volta à busca */
      if (sem){ a.setAttribute('aria-disabled', 'true'); a.setAttribute('tabindex', '-1'); } else { a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex'); }
    });
    status.innerHTML = ativa ? '<b>' + plural(total, '1 answer found', '{n} answers found') + '</b>' : '';
    vazio.hidden = !(ativa && !total); root.classList.toggle('is-empty', ativa && !total);
    if (ativa && !total){
      root.querySelectorAll('[data-npp-fq-q],[data-npp-fq-q2]').forEach(function(e){ e.textContent = q.trim(); });
      pedir.href = '/pages/contact?q=' + encodeURIComponent(q.trim());
    }
    limpar.hidden = !q;
    /* ?q= na URL: dá para mandar o link da busca */
    try { var u = new URL(location.href); if (ativa) u.searchParams.set('q', q.trim()); else u.searchParams.delete('q'); u.searchParams.delete('estado'); history.replaceState(null, '', u); } catch (e) {}
    espiar();
  }
  var tm = 0;
  input.addEventListener('input', function(){ clearTimeout(tm); tm = setTimeout(function(){ buscar(input.value); }, 120); });
  input.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && input.value){ e.preventDefault(); input.value = ''; buscar(''); }
    if (e.key === 'Enter'){ e.preventDefault(); clearTimeout(tm); buscar(input.value, true); input.blur(); irPara(root.querySelector('[data-npp-fq-it]:not([hidden])') || vazio); }
  });
  limpar.addEventListener('click', function(){ input.value = ''; buscar(''); input.focus(); });
  root.querySelectorAll('[data-npp-fq-try]').forEach(function(b){
    b.addEventListener('click', function(){ input.value = b.getAttribute('data-npp-fq-try'); buscar(input.value); input.focus({ preventScroll: true }); });
  });

  /* ---------- categorias: scrollspy e barra de leitura (categoria sem resultado fica apagada na busca) ---------- */
  function navH(){ return MQ.matches ? nav.offsetHeight : 0; }
  function topo(){ return (parseFloat(getComputedStyle(doc).getPropertyValue('--nph-h')) || 0) + navH(); }
  /* no celular o cabeçalho some ao descer e volta ao subir: o destino conta com ele só quando a rolagem é para cima */
  function irPara(el){
    if (!el) return;
    var cab = document.querySelector('.nph'), y = el.getBoundingClientRect().top + scrollY, sobe = y < scrollY,
        alto = MQ.matches ? (sobe && cab ? cab.offsetHeight : 0) : (parseFloat(getComputedStyle(doc).getPropertyValue('--nph-h')) || 0);
    scrollTo({ top: Math.max(0, y - alto - navH() - 20), behavior: CALMO.matches ? 'auto' : 'smooth' });
  }
  var pedido = 0, atual = '';
  function espiar(){
    pedido = 0;
    root.style.setProperty('--npp-fq-nav', navH() + 'px');
    var lim = topo() + 90, cur = 'all';
    grupos.forEach(function(g){ if (!g.hidden && g.getBoundingClientRect().top <= lim) cur = g.id; });
    if (cur !== atual){
      atual = cur;
      abas.forEach(function(a){ var on = a.getAttribute('data-npp-fq-tab') === cur; a.classList.toggle('is-on', on); if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); });
      var ativa = barra.querySelector('.is-on');
      if (MQ.matches && ativa) barra.scrollTo({ left: Math.max(0, barra.scrollLeft + ativa.getBoundingClientRect().left - barra.getBoundingClientRect().left - 16), behavior: CALMO.matches ? 'auto' : 'smooth' });
    }
    var r = main.getBoundingClientRect(), feito = Math.min(1, Math.max(0, (lim - r.top) / Math.max(1, r.height - innerHeight + lim)));
    nav.style.setProperty('--read', (feito * 100).toFixed(1) + '%');
  }
  addEventListener('scroll', function(){ if (!pedido) pedido = requestAnimationFrame(espiar); }, { passive: true });
  addEventListener('resize', function(){ atual = ''; espiar(); });
  abas.forEach(function(a){
    a.addEventListener('click', function(e){
      e.preventDefault(); if (a.classList.contains('is-none')) return;
      var id = a.getAttribute('data-npp-fq-tab'), alvo = id === 'all' ? root.querySelector('.npp-fq__find') : document.getElementById(id);
      irPara(alvo);
      try { history.replaceState(null, '', id === 'all' ? location.pathname + location.search : '#' + id); } catch (er) {}
    });
  });

  /* ---------- entrada: ?q= (e, só na prévia, ?estado=) · #categoria · #pergunta ---------- */
  var p = new URLSearchParams(location.search), q = p.get('q'),
      estado = null;
  if (estado) q = estado;
  if (q){ input.value = q; buscar(q); }
  var h = decodeURIComponent(location.hash.slice(1)), alvo = h && document.getElementById(h);
  if (alvo && alvo.hasAttribute('data-npp-fq-it')) abrir(alvo, true);
  if (alvo) setTimeout(function(){ irPara(alvo); }, 60);
  espiar();
})();
